<template>
  <v-expansion-panels
    v-model="panel"
    focusable
    class="mt-12"
  >
    <v-expansion-panel
      v-for="(faqQuestionReponse, indexQuestion) in theme.questionsReponses"
      :key="indexQuestion"
      @click="selectQuestion(faqQuestionReponse)"
    >
      <v-expansion-panel-header
        class="pl-4 hauteur-panel"
        :class="isQuestionSelected(faqQuestionReponse.id) ? 'theme-selected-color' : 'theme'"
      >
        <div class="text-md-left">
          <v-row no-gutters>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-card-text class="text-subtitle-1">
                {{ faqQuestionReponse.intitule }}
              </v-card-text>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-chip
                v-if="isNouveauteActive(faqQuestionReponse)"
                small
                class="ml-2"
                color="red"
                text-color="white"
              >
                <span class="pr-0 pr-md-1">
                  nouveauté!
                </span>
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </v-expansion-panel-header>
      <v-divider />
      <v-expansion-panel-content>
        <div class="mt-4 ml-2 text-justify">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="faqQuestionReponse.reponseOrdinateur" />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import faqService from '@/service/faq.service'
import {clone} from '@/utils/clone'
import { mapActions } from 'vuex'

export default {
  name: 'FaqQuestionsReponses',
  props: {
    theme: {
      type: Object,
      default: () => { }
    }
  },

  data () {
    return {
      panel: [],
      isAffichageQuestionsReponses: false,
      questionSelected: null
    }
  },

  methods: {
    ...mapActions({
      readQuestion: 'faq/readQuestion'
    }),
    isNouveauteActive (questionReponse) {
      return faqService.isQuestionReponseNouveauteActive(questionReponse) && this.$cookies.get('FAQ_QUESTION_DEJA_VU_' + questionReponse.id) == null
    },
    selectQuestion (question) {
      if (this.isAffichageQuestionsReponses && (this.questionSelected == null || question.id === this.questionSelected.id)) {
        this.isAffichageQuestionsReponses = false
        this.questionSelected = null
      } else {
        this.isAffichageQuestionsReponses = true
        this.questionSelected = clone(question)
        this.readQuestion(question)
        this.$emit('refreshNouveauteTheme')
      }
    },
    isQuestionSelected (questionID) {
      return this.questionSelected ? this.questionSelected.id === questionID : false
    }
  }

}
</script>

<style lang="scss" scoped>
.font-reponse {
  font-size: 17px;
  color: black;
}
.hauteur-panel {
  height: 40px;
}
.theme-selected-color {
  color: #967a27;
}
.theme {
  color: black;
  border-top: 1px solid #e0e0e0;
}
</style>
